export default __webpack_public_path__ + "static/thanks-banner-7255799d0237c83a5eda415d663090a8.webp";